import { QUANTITY_TYPES_DATA } from '../actions/actionType'
const initialState = {
  quantityTypes: [],
}
export default function QuantityTypesReducer(state = initialState, action) {
  switch (action.type) {
    case QUANTITY_TYPES_DATA:
      return { ...state, quantityTypes: action.payload }
    default:
      return state
  }
}
